import { MonitoringCategory } from "@domain/product/monitoring/monitoring-product.service";
import { FgdsProductType } from "@domain/product/product";
import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export class FloorplanItemReference {
  @IsString()
  @Expose({ name: "floorplanId" })
  _floorplanId: string;

  @IsString()
  @Expose({ name: "floorplanProductItemId" })
  _floorplanProductItemId: string;

  @IsString()
  @Expose({ name: "kind" })
  _kind: FgdsProductType | MonitoringCategory;

  constructor(floorplanId: string, floorplanProductItemId: string, kind: FgdsProductType | MonitoringCategory) {
    this._floorplanId = floorplanId;
    this._floorplanProductItemId = floorplanProductItemId;
    this._kind = kind;
  }

  get floorplanId(): string {
    return this._floorplanId;
  }

  set floorplanId(floorplanId: string) {
    this._floorplanId = floorplanId;
  }

  get floorplanProductItemId(): string {
    return this._floorplanProductItemId;
  }

  get kind(): FgdsProductType | MonitoringCategory {
    return this._kind;
  }
}
